// @flow

// force flow to type check this file - https://github.com/zapier/zapier/pull/31127
import React from 'react'; /* eslint-disable-line no-unused-vars */

import { Colors } from '@zapier/theme';
import { Icon } from '@zapier/common-components';
import { Link } from '@zapier/design-system';
/** @jsx jsx */
import { jsx } from '@emotion/core';

type Props = {
  className?: string,
};

const Styles = {
  link: {
    borderRadius: '50%',
    backgroundColor: Colors.steel,
    height: '30px',
    width: '30px',
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: Colors.white,
    margin: '4px',
  },
};

const SocialLinks = (props: Props) => {
  const { className } = props;

  return (
    <div className={className}>
      <span css={Styles.link}>
        <Link
          color="inherit"
          href="http://www.facebook.com/ZapierApp?utm_source=zapier.com&amp;utm_medium=referral&amp;utm_campaign=zapier"
          role="link"
          title="Follow us on Facebook"
        >
          <Icon name="facebook" />
        </Link>
      </span>

      <span css={Styles.link}>
        <Link
          color="inherit"
          href="http://www.linkedin.com/company/zapier/?utm_source=zapier.com&amp;utm_medium=referral&amp;utm_campaign=zapier"
          role="link"
          title="Follow us on LinkedIn"
        >
          <Icon name="linkedin" />
        </Link>
      </span>

      <span css={Styles.link}>
        <Link
          color="inherit"
          href="https://twitter.com/?utm_source=zapier.com&amp;utm_medium=referral&amp;utm_campaign=zapier#!/zapier"
          role="link"
          title="Follow @zapier on Twitter"
        >
          <Icon name="social-twitter" />
        </Link>
      </span>

      <span css={Styles.link}>
        <Link
          color="inherit"
          href="http://www.youtube.com/user/ZapierApp/videos?utm_source=zapier.com&amp;utm_medium=referral&amp;utm_campaign=zapier"
          role="link"
          title="See helpful Zapier videos on Youtube"
        >
          <Icon name="youtube" />
        </Link>
      </span>

      <span css={Styles.link}>
        <Link
          color="inherit"
          href="/blog/feeds/latest/"
          role="link"
          title="Subscribe to our blog"
        >
          <Icon name="rss" />
        </Link>
      </span>
    </div>
  );
};

export default SocialLinks;
